// extracted by mini-css-extract-plugin
export default {"SocialLinks":"SocialLinks_SocialLinks__FSro1","slide-in":"SocialLinks_slide-in__EaGy8"};